<template>
  <div
    id="confirmation-modal"
    class="modal-container"
    tabindex="0"
    :class="{ one: (initialized && isOpen) || closed, out: closed }"
    @keydown.esc="closeModal()"
  >
    <div class="modal-background" @click="closeModal()" />
    <div class="modal-box">
      <!-- Modal content -->
      <div
        @click.prevent
        class="modal mx-auto fixed bottom-0 left-0 flex flex-col"
        :class="[size, bgColor]"
      >
        <template v-if="!loading">
          <div class="flex-grow flex justify-center items-center">
            <slot />
          </div>
          <div
            @click="confirm"
            class="grid grid-cols-1 w-full h-11 border-t border-gray-400 items-center"
          >
            <div class="font-button text-pink-300">
              {{ confirmText != "" ? confirmText : confirmDefaultMessage }}
            </div>
          </div>
        </template>
        <template v-else>
          <div class="flex justify-center items-center w-full h-full">
            <div class="loading">
              <Spinner class="bg-white" />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import Spinner from "@/components/shared/Spinner.vue";

//todo => add prop with animation type, define different types of animation
export default {
  components: {
    Spinner
  },
  name: "ModalComponent",
  props: {
    value: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: "h-44 w-72"
    },
    bgColor: {
      type: String,
      required: false,
      default: "bg-gray-50"
    },
    confirmText: {
      type: String,
      required: false,
      default: ""
    },
    cancelText: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      closed: false,
      isOpen: false,
      initialized: true
    };
  },
  computed: {
    confirmDefaultMessage() {
      return this.$t("message.confirm");
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.closed = false;
        this.isOpen = true;
        this.initialized = true;
      } else {
        if (this.isOpen) {
          this.closeModal();
        }
      }
    }
  },
  methods: {
    confirm() {
      this.$emit("acepted");
      this.closeModal();
    },
    closeModal() {
      this.closed = true;
      setTimeout(() => {
        this.isOpen = false;
        this.$emit("input", false);
        this.closed = false;
      }, 800);
    }
  }
};
</script>
<style lang="postcss" scoped>
/* The Modal (background) */
.modal-container {
  position: fixed;
  display: table;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  transform: scale(0);

  .modal-background {
    position: absolute;
    background: rgb(0 0 0 / 40%);
    width: 100%;
    height: 100%;
  }

  .modal-box {
    display: table-cell;
    text-align: center;
    vertical-align: middle;

    .modal {
      background: white;
      border-radius: 14px;
      border: 1px solid;

      @apply border-gray-200;

      font-weight: 300;
      position: relative;

      h2 {
        font-size: 25px;
        line-height: 25px;
        margin-bottom: 15px;
      }

      p {
        font-size: 18px;
        line-height: 22px;
      }

      .modal-svg {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        border-radius: 3px;

        rect {
          stroke: #fff;
          stroke-width: 2px;
          stroke-dasharray: 778;
          stroke-dashoffset: 778;
        }
      }
    }
  }

  &:focus {
    border: none;
    outline: none;
  }

  &.one {
    transform: scaleY(1) scaleX(1);

    .modal-background {
      transform: scaleY(0.01) scaleX(0);
      animation: unfold-in 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
    }

    .modal-box {
      .modal {
        transform: scale(0);
        animation: zoom-in 0.3s 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
      }
    }

    &.out {
      animation: unfold-out 0s 1.3s forwards;

      .modal-background {
        transform: scale(1);
        animation: unfold-out 1s 0.3s cubic-bezier(0.165, 0.84, 0.44, 1)
          forwards;
      }

      .modal-box {
        .modal {
          animation: zoom-out 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
        }
      }
    }
  }
}

@keyframes unfold-in {
  0% {
    transform: scaleY(0.005) scaleX(0);
  }

  50% {
    transform: scaleY(0.005) scaleX(1);
  }

  100% {
    transform: scaleY(1) scaleX(1);
  }
}

@keyframes unfold-out {
  0% {
    transform: scaleY(1) scaleX(1);
  }

  50% {
    transform: scaleY(0.005) scaleX(1);
  }

  100% {
    transform: scaleY(0.005) scaleX(0);
  }
}

@keyframes zoom-in {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes zoom-out {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0);
  }
}
</style>
